export default function VideoPreview({
  src,
  type,
}: {
  src: string;
  type: string;
}) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <video controls className="h-auto max-h-[70vh] max-w-full">
        <source src={src} type={type} />
      </video>
    </div>
  );
}
